module.exports = __webpack_public_path__ + "img/covid-cancer-diagram-legend.6da3bdc8.png";